import { memo, useEffect, useState } from 'react'

import { UserFeedback } from '#/components/ErrorBoundary/UserFeedback'
import { useUserInfo } from '#/store/ducks/auth'
import { useCompanySlug } from '#/store/ducks/company'
import { useFarmSlug } from '#/store/ducks/farm'
import { Sentry } from '#/store/services/Sentry'
import { listeners } from '#/utils/listeners'

const whitelist = ['/system/settings/tests']

export type DetailError = {
  error_id: string
  status_code: number
}

function ErrorBoundary({ children }) {
  const [error, setError] = useState<DetailError | false>(false)

  const userInfo = useUserInfo() as any
  const farmSlug = useFarmSlug()
  const companySlug = useCompanySlug()

  const backendError = event => {
    setError(event.detail as DetailError)
  }
  /**
   * Event Listener
   */
  useEffect(() => {
    window.addEventListener(listeners.errorboundary, backendError)

    return () => {
      window.removeEventListener(listeners.errorboundary, backendError)
    }
  }, [])

  /**
   * Erros retornados pelo backend
   */
  if (error && !whitelist.includes(window.location.pathname)) {
    return <UserFeedback eventId={error.error_id} error={error} user={userInfo} />
  }

  /**
   * Adiciona informações de usuário ao sentry
   */
  const sessionScope = scope => {
    scope.setUser({
      email: userInfo.email,
      id: userInfo.uuid,
      username: userInfo.name,
    })

    /**
     * Adiciona o slug da fazenda ao sentry
     */
    if (farmSlug) {
      scope.setTag('farm', farmSlug)
    }

    /**
     * Adiciona o slug da empresa ao sentry
     */
    if (companySlug) {
      scope.setTag('company', companySlug)
    }
  }

  return (
    <Sentry.ErrorBoundary
      beforeCapture={sessionScope}
      fallback={({ error, eventId }) => {
        return <UserFeedback eventId={eventId} error={error as any} user={userInfo} />
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}

export default memo(ErrorBoundary)
